import { useLocation } from 'react-router-dom';

import type { Direction } from './welcome-message-utils';

/**
 * Derives the welcome-message direction from the current route. Inbound admin
 * pages live under `/welcome-messages/inbound`; every other welcome page
 * (including all non-service ones) resolves to 'outbound'.
 */
export const useWelcomeDirection = (): Direction =>
  useLocation().pathname.includes('/welcome-messages/inbound')
    ? 'inbound'
    : 'outbound';
